import {Warning} from './icons';
import notices from './notices';

export const teamCheckActiveTournament = (team, popup) => {
  if(team.get('has_active_tournament')) {
    popup.set({
      icon: Warning,
      message: notices.teamHasActiveTournament,
      action: 'Понятно',
      iconWidth: 128,
      iconHeight: 128,
      autoClose: true
    });
    return false;
  }
  return true;
};


// WEBPACK FOOTER //
// ./src/components/teamCheckActiveTournament.js